/// <amd-module name="Widgets/AnalyticsSprintBurndown/AnalyticsSprintBurndownWidgetComponents/TfsQueries/TeamDaysOffCacheableQuery" />
import { TeamSettingsDaysOff } from "Dashboards/Clients/contracts/Work";
import { getWorkClient, IWorkRestClient } from "Dashboards/Clients/Work";
import { ICacheableQuery } from "Reporting/Common/ICacheableQuery";
import { IProjectData } from "Tfs/Platform/Page";
import * as TfsWidgetContext from "Tfs/Widget/Context";
import { IVssPageContext } from "VSS/Platform/Context";

export class TeamDaysOffCacheableQuery implements ICacheableQuery<TeamSettingsDaysOff> {
    private projectData: IProjectData;
    private teamId: string;
    private iterationId: string;

    constructor(private pageContext: IVssPageContext, teamId: string, iterationId: string) {
        this.projectData = TfsWidgetContext.getProject(this.pageContext);
        this.teamId = teamId;
        this.iterationId = iterationId;
    }

    public async runQuery(pageContext: IVssPageContext): Promise<TeamSettingsDaysOff> {
        const workClient: IWorkRestClient = getWorkClient(pageContext);
        const teamContext = {
            project: this.projectData.id,
            projectId: this.projectData.id,
            team: this.teamId,
            teamId: this.teamId
        };
        return workClient.getTeamDaysOff(teamContext, this.iterationId);
    }

    public getKey(): string {
        return (
            "TeamDaysOffCacheableQuery" +
            JSON.stringify({
                projectId: this.projectData.id,
                teamId: this.teamId,
                iterationId: this.iterationId
            })
        );
    }
}
